export * from './use-search-corporations-in-national-tax-agency'
export type { SearchCorporationsInNationalTaxAgency200ResponseInner as SearchCorporationsInNationalTaxAgency } from '@src/api/generated/user-api'
